/* eslint-disable */
if (process.env.NODE_ENV === 'production') {
    if (process.env.AFFIXE2_ENV === 'staging') {
        module.exports = require('./config.staging');
    } else {
        module.exports = require('./config.prod');
    }
} else {
    module.exports = require('./config.dev');
}
//module.exports = require('./config.prod');


// WEBPACK FOOTER //
// ./src/api/config/config.js